<template>
  <div class="jdPopModel">
    <div class="wrapper model">
      <el-form ref="form" :model="form" label-width="170px">
        <el-row :gutter="22">
          <el-col :span="12">
            <el-form-item label="仪器名称：">
              <el-input v-model="form.instrumentName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="生产厂商：">
              <el-input v-model="form.factoryName" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="12">
            <el-form-item label="仪器编号：">
              <el-input v-model="form.serialNumber" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备型号：">
              <el-input v-model="form.pattern" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="12">
            <el-form-item label="上次检定准确度：">
              <el-input v-model="form.accuracy" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上次检定时间：">
              <el-input v-model="form.lastCalibrationTime" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="12">
            <el-form-item label="检定/校准单位：">
              <el-input  maxlength="100" v-model="form.calibrationMechanism"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="12">
            <el-form-item label="本次检定准确度：">
              <el-input  maxlength="100" v-model="form.currentAccuracy"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="本次检定/校准日期：">
              <el-date-picker value-format="yyyy-MM-dd" v-model="form.calibrationTime" class="date-picker" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="12">
            <el-form-item label="证书编号：">
              <el-input maxlength="100"  v-model="form.certificate"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="下次检定/校准有效期：">
              <el-date-picker value-format="yyyy-MM-dd" class="date-picker" v-model="form.nextCalibrationTime" type="date" placeholder="选择日期">
              </el-date-picker>
              <!-- <el-input v-model="form.nextCalibrationTime"></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col :span="12">
            <el-form-item label="测量范围：">
              <el-input  maxlength="100" v-model="form.measuringRange"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态：">
              <el-select :poper-append-to-body="false" popper-class="my-select" v-model="form.states" placeholder="请选择">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col>
            <el-form-item label="检定要求：">
              <el-input  maxlength="300" type="textarea" v-model="form.requirements"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="22">
          <el-col>
            <el-form-item label="检定/校准结果上传：">
              <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                :http-request="fileUpload"
                :file-list="files"
              >
                <el-button>选取文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="22">
          <el-col>
            <el-form-item label="证书截图上传：">
              <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                :http-request="myupload"
                :show-file-list="false"
                :accept="'image/*'"
                :before-upload="handleBeforeUpload"
              >
                <img v-if="imgURL" :src="imgURL" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row :gutter="22">
          <el-col>
            <el-form-item label="检定校准结果确认：">
              <el-input  maxlength="300" type="textarea" v-model="form.resultStr"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="footer">
      <div class="my-buttom select-buttom btn" @click="dispose(true)">确认</div>
      <div class="my-buttom btn" @click="dispose(false)">取消</div>
    </div>
  </div>
</template>
<script>
import { FileUrl } from "@/api/depotApi";
import axios from '@/util/request';
export default {
  props: {
    message: Object,
  },
  computed: {
    particular() {
      return this.message;
    },
  },
  data() {
    return {
      uploadUrl: "/admin/sys-file/upload", //上传地址
      imgURL: "", //证书截图在线地址
      certFileURL: "", //证书文件在线地址
      imageUrl: "",
      form: {
        instrumentName: "", //仪器名称
        serialNumber: "", //仪器编号
        factoryName: "", //生产厂商
        pattern: "", //设备型号
        measuringRange: "", //测量范围
        accuracy: "", //上次检定准确度
        lastCalibrationTime: "",
        currentAccuracy: "", //本次检定准确度
        calibrationMechanism: "", //检定/校准单位
        calibrationTime: "", //检定校准日期
        certificate: "", //证书编号
        nextCalibrationTime: "", //下次检定/校准有效期
        requirements: "", //检定要求
        photo: "", //证书截图
        resultStr: "", //检定校准结果确认
        states: "", //状态
        id: "",
        certFile:''//证书文件
      },
      options: [
        {
          value: 0,
          label: "正常",
        },
        {
          value: 1,
          label: "降级",
        },
        {
          value: 2,
          label: "停用",
        },
        {
          value: 3,
          label: "需维修",
        },
        {
          value: 4,
          label: "需检定",
        },
        {
          value: 5,
          label: "需保养",
        },
        {
          value: 6,
          label: "报废",
        },
      ],
      files: [],
    };
  },
  mounted() {
    Object.keys(this.form).forEach((key) => {
      if (
        key == "id" ||
        key == "states" ||
        key == "pattern" ||
        key == "instrumentName" ||
        key == "serialNumber" ||
        key == "requirements" ||
        key == "accuracy" ||
        key == "factoryName" ||
        key == "calibrationMechanism" ||
        key == "lastCalibrationTime"
      ) {
        this.form[key] = this.particular[key];
      }
    });
  },
  methods: {
    dispose(item) {
      let bolVal = item;
      const pick = (obj, arr) =>
        arr.reduce(
          (iter, val) => (val in obj && (iter[val] = obj[val]), iter),
          {}
        );
      let data = pick(this.form, [
        "id",
        "requirements",
        "states",
        "resultStr",
        "photo",
        "nextCalibrationTime",
        "calibrationTime",
        "calibrationMechanism",
        "certificate",
        "currentAccuracy",
        "measuringRange",
        "certFile",
      ]);
      if (bolVal) {
        if (!data.currentAccuracy) {
          this.$message({
            message: "请输入本次检定准确度",
            type: "warning",
          });
          return false;
        }
        if (!data.calibrationMechanism) {
          this.$message({
            message: "单位不能为空",
            type: "warning",
          });
          return false;
        }
        if (!data.calibrationTime) {
          this.$message({
            message: "检定校准日期不能为空",
            type: "warning",
          });
          return false;
        }
        if (!data.certificate) {
          this.$message({
            message: "证书编号不为空",
            type: "warning",
          });
          return false;
        }
        if (!data.nextCalibrationTime) {
          this.$message({
            message: "下次检定/校准有效期不为空",
            type: "warning",
          });
          return false;
        }
        if (!data.measuringRange) {
          this.$message({
            message: "测量范围不为空",
            type: "warning",
          });
          return false;
        }
        if (!data.requirements) {
          this.$message({
            message: "请填写检定要求",
            type: "warning",
          });
          return false;
        }
        if (!data.certFile) {
          this.$message({
            message: "请上传检定/校准结果",
            type: "warning",
          });
          return false;
        }
        // if (!data.photo) {
        //   this.$message({
        //     message: "请上传证书截图",
        //     type: "warning",
        //   });
        //   return false;
        // }
        if (!data.resultStr) {
          this.$message({
            message: "请填写检定校准结果",
            type: "warning",
          });
          return false;
        }
      } else {
      }
      //用于解决后台日期格式问题
      data.calibrationTime = data.calibrationTime ;
      data.nextCalibrationTime = data.nextCalibrationTime ;
      this.$emit("dispose", bolVal, data);
    },
    myupload(item) {
      let that = this;
      let fileObj = item.file;
      const form = new FormData();
      form.append("file", fileObj);
      axios({
        url: item.action,
        headers: { 'Content-Type': 'multipart/form-data' },
        method: 'post',
        data: form
      }).then(res => {
        if (res.succeed) {
          that.form.photo = res.data.fileName;
          FileUrl({ objectName: res.data.fileName }).then((res) => {
            that.imgURL = res.data;
          });
        }
        else {
          that.$message.error(res.msg);
        }
      }).catch((data) => {
        that.$message.error("上传失败,请重新上传图片!");
      });
    },
    handleBeforeUpload(file) {
      const isImage = file.type.includes("image");
      if (!isImage) {
        this.$message.error("上传文件类型必须是图片!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isImage && isLt2M;
    },
    fileUpload(item) {
      let that = this;
      let fileObj = item.file;
      this.files = [fileObj];
      const form = new FormData();
      form.append("file", fileObj);
      axios({
        url: item.action,
        headers: { 'Content-Type': 'multipart/form-data' },
        method: 'post',
        data: form
      }).then(res => {
        if (res.succeed) {
          that.form.certFile = res.data.fileName;
          FileUrl({ objectName: res.data.fileName }).then((res) => {
            that.certFileURL = res.data;
          });
        }
        else {
          that.$message.error(res.msg);
        }
      }).catch((data) => {
        that.$message.error("上传失败,请重新上传!");
      });
    },
  },
};
</script>

<style lang="less" scopde>
.jdPopModel {
  width: 100%;
  // height: 360px;
  color: #74c8fe;
  .wrapper {
    width: 100%;
    /deep/ .el-form-item__label {
      color: #74c8fe;
    }
    /deep/ .el-form-item {
      margin-bottom: 5px;
    }
    /deep/ .el-input__inner {
      border: 2px solid #0090f0 !important;
    }
    /deep/ .el-date-editor {
      width: 100%;
    }
    /deep/ .el-select {
      width: 100%;
    }
    /deep/ .el-input__prefix {
      display: none;
    }
  }
  .footer {
    clear: both;
    width: 100%;
    height: 60px;
    line-height: 60px;
    text-align: center;
  }
  .avatar-uploader .el-upload {
    border: 2px solid #0090f0;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #74c8fe;
    width: 108px;
    height: 108px;
    line-height: 108px;
    text-align: center;
  }
  .avatar {
    width: 108px;
    height: 108px;
    display: block;
  }
  .el-input.is-disabled .el-input__inner {
    color: #74c8fe;
    background-color: initial;
    border: 2px solid #74c8fe;
  }
  .el-input__inner,.el-textarea__inner {
    color: #74c8fe;
    background-color: initial;
    border: 2px solid #74c8fe !important;
  }
  .el-form-item__label{
    color: #74c8fe;
  }
  .el-select {
    width: 100%;
    .el-input__suffix {
      .el-input__icon {
        line-height: 30px !important;
      }
    }
  }
  .date-picker {
    width: 100%;
    .el-input__prefix {
      display: none;
    }
    .el-input__suffix {
      top: -5px;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/maintenance/components/jdPopModel1.vue